import { render, staticRenderFns } from "./CallbacksList.vue?vue&type=template&id=6070a1c8&scoped=true"
import script from "./CallbacksList.vue?vue&type=script&lang=js"
export * from "./CallbacksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070a1c8",
  null
  
)

export default component.exports